/**
 * Normalise a color-token string to a valid CSS color expression.
 *
 * The slice / Sheet stores color tokens in two interchangeable forms:
 *  - bare: `'--cat-food'`  (the raw CSS variable name)
 *  - wrapped: `'var(--cat-food)'`  (already a CSS color expression)
 *  - literal: `'#A89068'` or `'rgb(...)'` (free color)
 *
 * `background: '--cat-food'` is INVALID CSS and silently renders nothing,
 * which was the root cause of the "category icons / dots invisible" bug.
 * Use this helper anywhere a stored color_token is fed into a CSS value.
 */
export function cssColor(token: string | undefined | null, fallback = 'var(--cat-other)'): string {
  if (!token) return fallback;
  if (token.startsWith('--')) return `var(${token})`;
  return token;
}
